// source: messaging/camera_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var messaging_camera_status_pb = require('../messaging/camera_status_pb.js');
goog.object.extend(proto, messaging_camera_status_pb);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.Facing', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ResolutionChangeCapability', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ZoomCapability', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraHealthStatusRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraHealthStatusResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraInfoControls', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraLogRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraLogRequest.CameraLogType', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraLogResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraSnapshotRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraSnapshotResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraStatusRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraStatusResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ConfigReloadRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ConfigReloadRequest.ConfigType', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.UpdateViewerCapability', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.UpdateViewerCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.UpdateViewerCapability.displayName = 'proto.com.alfredcamera.protobuf.UpdateViewerCapability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.displayName = 'proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.repeatedFields_, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.displayName = 'proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.displayName = 'proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.displayName = 'proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraSnapshotRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraSnapshotRequest.displayName = 'proto.com.alfredcamera.protobuf.CameraSnapshotRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraSnapshotResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraSnapshotResponse.displayName = 'proto.com.alfredcamera.protobuf.CameraSnapshotResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraStatusRequest.displayName = 'proto.com.alfredcamera.protobuf.CameraStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraStatusResponse.displayName = 'proto.com.alfredcamera.protobuf.CameraStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ConfigReloadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ConfigReloadRequest.displayName = 'proto.com.alfredcamera.protobuf.ConfigReloadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraHealthStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.displayName = 'proto.com.alfredcamera.protobuf.CameraHealthStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.repeatedFields_, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraHealthStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.displayName = 'proto.com.alfredcamera.protobuf.CameraHealthStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraLogRequest.displayName = 'proto.com.alfredcamera.protobuf.CameraLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraLogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraLogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraLogResponse.displayName = 'proto.com.alfredcamera.protobuf.CameraLogResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.UpdateViewerCapability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.UpdateViewerCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.toObject = function(includeInstance, msg) {
  var f, obj = {
    protocolVersion: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.UpdateViewerCapability}
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.UpdateViewerCapability;
  return proto.com.alfredcamera.protobuf.UpdateViewerCapability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.UpdateViewerCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.UpdateViewerCapability}
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProtocolVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.UpdateViewerCapability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.UpdateViewerCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProtocolVersion();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 protocol_version = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.prototype.getProtocolVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.UpdateViewerCapability} returns this
 */
proto.com.alfredcamera.protobuf.UpdateViewerCapability.prototype.setProtocolVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest;
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    protocol: jspb.Message.getFieldWithDefault(msg, 1, 0),
    datachannel: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cameraPipeline: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cameraSensorCapabilityList: jspb.Message.toObjectList(msg.getCameraSensorCapabilityList(),
    proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.toObject, includeInstance),
    hardware: jspb.Message.getFieldWithDefault(msg, 16, 0),
    batteryless: jspb.Message.getFieldWithDefault(msg, 17, 0),
    statusLed: jspb.Message.getFieldWithDefault(msg, 18, 0),
    irNightVision: jspb.Message.getFieldWithDefault(msg, 19, 0),
    disableCamera: jspb.Message.getFieldWithDefault(msg, 101, 0),
    lowlightFilter: jspb.Message.getFieldWithDefault(msg, 102, 0),
    orientationControl: jspb.Message.getFieldWithDefault(msg, 103, 0),
    rotationSetting: jspb.Message.getFieldWithDefault(msg, 104, 0),
    autoPowerSaving: jspb.Message.getFieldWithDefault(msg, 105, 0),
    recordingAudio: jspb.Message.getFieldWithDefault(msg, 106, 0),
    osd: jspb.Message.getFieldWithDefault(msg, 107, 0),
    maxConnectedViewer: jspb.Message.getFieldWithDefault(msg, 201, 0),
    accessPriority: jspb.Message.getFieldWithDefault(msg, 202, 0),
    twoWayAudio: jspb.Message.getFieldWithDefault(msg, 203, 0),
    manualRecording: jspb.Message.getFieldWithDefault(msg, 204, 0),
    siren: jspb.Message.getFieldWithDefault(msg, 205, 0),
    resolutionChange: jspb.Message.getFieldWithDefault(msg, 206, 0),
    zoom: jspb.Message.getFieldWithDefault(msg, 207, 0),
    detectionModeMotion: jspb.Message.getFieldWithDefault(msg, 301, 0),
    detectionModePerson: jspb.Message.getFieldWithDefault(msg, 302, 0),
    detectionReminder: jspb.Message.getFieldWithDefault(msg, 303, 0),
    detectionSchedule: jspb.Message.getFieldWithDefault(msg, 304, 0),
    detectionZone: jspb.Message.getFieldWithDefault(msg, 305, 0),
    liveAndDetection: jspb.Message.getFieldWithDefault(msg, 306, 0),
    continuousRecording: jspb.Message.getFieldWithDefault(msg, 307, 0),
    cameraHealth: jspb.Message.getFieldWithDefault(msg, 401, 0),
    cameraLog: jspb.Message.getFieldWithDefault(msg, 402, 0),
    appLock: jspb.Message.getFieldWithDefault(msg, 501, 0),
    rebootCamera: jspb.Message.getFieldWithDefault(msg, 601, 0),
    networkStatus: jspb.Message.getFieldWithDefault(msg, 602, 0),
    firmwareUpdate: jspb.Message.getFieldWithDefault(msg, 603, 0),
    sdcardManagement: jspb.Message.getFieldWithDefault(msg, 604, 0),
    wifiManagement: jspb.Message.getFieldWithDefault(msg, 605, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse;
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProtocol(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDatachannel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCameraPipeline(value);
      break;
    case 4:
      var value = new proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.deserializeBinaryFromReader);
      msg.addCameraSensorCapability(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHardware(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBatteryless(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatusLed(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIrNightVision(value);
      break;
    case 101:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisableCamera(value);
      break;
    case 102:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLowlightFilter(value);
      break;
    case 103:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability} */ (reader.readEnum());
      msg.setOrientationControl(value);
      break;
    case 104:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability} */ (reader.readEnum());
      msg.setRotationSetting(value);
      break;
    case 105:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAutoPowerSaving(value);
      break;
    case 106:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordingAudio(value);
      break;
    case 107:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOsd(value);
      break;
    case 201:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxConnectedViewer(value);
      break;
    case 202:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccessPriority(value);
      break;
    case 203:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTwoWayAudio(value);
      break;
    case 204:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setManualRecording(value);
      break;
    case 205:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSiren(value);
      break;
    case 206:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ResolutionChangeCapability} */ (reader.readEnum());
      msg.setResolutionChange(value);
      break;
    case 207:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ZoomCapability} */ (reader.readEnum());
      msg.setZoom(value);
      break;
    case 301:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDetectionModeMotion(value);
      break;
    case 302:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDetectionModePerson(value);
      break;
    case 303:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDetectionReminder(value);
      break;
    case 304:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDetectionSchedule(value);
      break;
    case 305:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDetectionZone(value);
      break;
    case 306:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLiveAndDetection(value);
      break;
    case 307:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContinuousRecording(value);
      break;
    case 401:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCameraHealth(value);
      break;
    case 402:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCameraLog(value);
      break;
    case 501:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAppLock(value);
      break;
    case 601:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRebootCamera(value);
      break;
    case 602:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNetworkStatus(value);
      break;
    case 603:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFirmwareUpdate(value);
      break;
    case 604:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSdcardManagement(value);
      break;
    case 605:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWifiManagement(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProtocol();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDatachannel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCameraPipeline();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCameraSensorCapabilityList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.serializeBinaryToWriter
    );
  }
  f = message.getHardware();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getBatteryless();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getStatusLed();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getIrNightVision();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getDisableCamera();
  if (f !== 0) {
    writer.writeInt32(
      101,
      f
    );
  }
  f = message.getLowlightFilter();
  if (f !== 0) {
    writer.writeInt32(
      102,
      f
    );
  }
  f = message.getOrientationControl();
  if (f !== 0.0) {
    writer.writeEnum(
      103,
      f
    );
  }
  f = message.getRotationSetting();
  if (f !== 0.0) {
    writer.writeEnum(
      104,
      f
    );
  }
  f = message.getAutoPowerSaving();
  if (f !== 0) {
    writer.writeInt32(
      105,
      f
    );
  }
  f = message.getRecordingAudio();
  if (f !== 0) {
    writer.writeInt32(
      106,
      f
    );
  }
  f = message.getOsd();
  if (f !== 0) {
    writer.writeInt32(
      107,
      f
    );
  }
  f = message.getMaxConnectedViewer();
  if (f !== 0) {
    writer.writeInt32(
      201,
      f
    );
  }
  f = message.getAccessPriority();
  if (f !== 0) {
    writer.writeInt32(
      202,
      f
    );
  }
  f = message.getTwoWayAudio();
  if (f !== 0) {
    writer.writeInt32(
      203,
      f
    );
  }
  f = message.getManualRecording();
  if (f !== 0) {
    writer.writeInt32(
      204,
      f
    );
  }
  f = message.getSiren();
  if (f !== 0) {
    writer.writeInt32(
      205,
      f
    );
  }
  f = message.getResolutionChange();
  if (f !== 0.0) {
    writer.writeEnum(
      206,
      f
    );
  }
  f = message.getZoom();
  if (f !== 0.0) {
    writer.writeEnum(
      207,
      f
    );
  }
  f = message.getDetectionModeMotion();
  if (f !== 0) {
    writer.writeInt32(
      301,
      f
    );
  }
  f = message.getDetectionModePerson();
  if (f !== 0) {
    writer.writeInt32(
      302,
      f
    );
  }
  f = message.getDetectionReminder();
  if (f !== 0) {
    writer.writeInt32(
      303,
      f
    );
  }
  f = message.getDetectionSchedule();
  if (f !== 0) {
    writer.writeInt32(
      304,
      f
    );
  }
  f = message.getDetectionZone();
  if (f !== 0) {
    writer.writeInt32(
      305,
      f
    );
  }
  f = message.getLiveAndDetection();
  if (f !== 0) {
    writer.writeInt32(
      306,
      f
    );
  }
  f = message.getContinuousRecording();
  if (f !== 0) {
    writer.writeInt32(
      307,
      f
    );
  }
  f = message.getCameraHealth();
  if (f !== 0) {
    writer.writeInt32(
      401,
      f
    );
  }
  f = message.getCameraLog();
  if (f !== 0) {
    writer.writeInt32(
      402,
      f
    );
  }
  f = message.getAppLock();
  if (f !== 0) {
    writer.writeInt32(
      501,
      f
    );
  }
  f = message.getRebootCamera();
  if (f !== 0) {
    writer.writeInt32(
      601,
      f
    );
  }
  f = message.getNetworkStatus();
  if (f !== 0) {
    writer.writeInt32(
      602,
      f
    );
  }
  f = message.getFirmwareUpdate();
  if (f !== 0) {
    writer.writeInt32(
      603,
      f
    );
  }
  f = message.getSdcardManagement();
  if (f !== 0) {
    writer.writeInt32(
      604,
      f
    );
  }
  f = message.getWifiManagement();
  if (f !== 0) {
    writer.writeInt32(
      605,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability = {
  ROTATION_NOT_SUPPORTED: 0,
  ROTATE_BY_90_DEGREES: 1,
  ROTATE_BY_180_DEGREES: 2
};

/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ResolutionChangeCapability = {
  RESOLUTION_CHANGE_NOT_SUPPORTED: 0,
  APP_TYPE_1: 1,
  HARDWARE_TYPE_1: 8
};

/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ZoomCapability = {
  ZOOM_NOT_SUPPORTED: 0,
  ZOOM_1: 1,
  ZOOM_2: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.toObject = function(includeInstance, msg) {
  var f, obj = {
    facing: jspb.Message.getFieldWithDefault(msg, 1, 0),
    torch: (f = msg.getTorch()) && proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability;
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.Facing} */ (reader.readEnum());
      msg.setFacing(value);
      break;
    case 106:
      var value = new proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.deserializeBinaryFromReader);
      msg.setTorch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFacing();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTorch();
  if (f != null) {
    writer.writeMessage(
      106,
      f,
      proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.Facing = {
  DEFAULT: 0,
  BACK: 1,
  FRONT: 2,
  EXTERNAL: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.toObject = function(includeInstance, msg) {
  var f, obj = {
    supported: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability;
  return proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupported(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupported();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool supported = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.prototype.getSupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability.prototype.setSupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Facing facing = 1;
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.Facing}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.getFacing = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.Facing} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.Facing} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.setFacing = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TorchCapability torch = 106;
 * @return {?proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.getTorch = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability, 106));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.TorchCapability|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability} returns this
*/
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.setTorch = function(value) {
  return jspb.Message.setWrapperField(this, 106, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.clearTorch = function() {
  return this.setTorch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability.prototype.hasTorch = function() {
  return jspb.Message.getField(this, 106) != null;
};


/**
 * optional int32 protocol = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getProtocol = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setProtocol = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 datachannel = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getDatachannel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setDatachannel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 camera_pipeline = 3;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getCameraPipeline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setCameraPipeline = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated CameraSensorCapability camera_sensor_capability = 4;
 * @return {!Array<!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability>}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getCameraSensorCapabilityList = function() {
  return /** @type{!Array<!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability, 4));
};


/**
 * @param {!Array<!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability>} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setCameraSensorCapabilityList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.addCameraSensorCapability = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.CameraSensorCapability, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.clearCameraSensorCapabilityList = function() {
  return this.setCameraSensorCapabilityList([]);
};


/**
 * optional int32 hardware = 16;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getHardware = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setHardware = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 batteryless = 17;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getBatteryless = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setBatteryless = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 status_led = 18;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getStatusLed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setStatusLed = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 ir_night_vision = 19;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getIrNightVision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setIrNightVision = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 disable_camera = 101;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getDisableCamera = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 101, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setDisableCamera = function(value) {
  return jspb.Message.setProto3IntField(this, 101, value);
};


/**
 * optional int32 lowlight_filter = 102;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getLowlightFilter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 102, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setLowlightFilter = function(value) {
  return jspb.Message.setProto3IntField(this, 102, value);
};


/**
 * optional RotationCapability orientation_control = 103;
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getOrientationControl = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability} */ (jspb.Message.getFieldWithDefault(this, 103, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setOrientationControl = function(value) {
  return jspb.Message.setProto3EnumField(this, 103, value);
};


/**
 * optional RotationCapability rotation_setting = 104;
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getRotationSetting = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability} */ (jspb.Message.getFieldWithDefault(this, 104, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.RotationCapability} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setRotationSetting = function(value) {
  return jspb.Message.setProto3EnumField(this, 104, value);
};


/**
 * optional int32 auto_power_saving = 105;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getAutoPowerSaving = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 105, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setAutoPowerSaving = function(value) {
  return jspb.Message.setProto3IntField(this, 105, value);
};


/**
 * optional int32 recording_audio = 106;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getRecordingAudio = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 106, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setRecordingAudio = function(value) {
  return jspb.Message.setProto3IntField(this, 106, value);
};


/**
 * optional int32 osd = 107;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getOsd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 107, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setOsd = function(value) {
  return jspb.Message.setProto3IntField(this, 107, value);
};


/**
 * optional int32 max_connected_viewer = 201;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getMaxConnectedViewer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 201, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setMaxConnectedViewer = function(value) {
  return jspb.Message.setProto3IntField(this, 201, value);
};


/**
 * optional int32 access_priority = 202;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getAccessPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 202, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setAccessPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 202, value);
};


/**
 * optional int32 two_way_audio = 203;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getTwoWayAudio = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 203, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setTwoWayAudio = function(value) {
  return jspb.Message.setProto3IntField(this, 203, value);
};


/**
 * optional int32 manual_recording = 204;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getManualRecording = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 204, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setManualRecording = function(value) {
  return jspb.Message.setProto3IntField(this, 204, value);
};


/**
 * optional int32 siren = 205;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getSiren = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 205, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setSiren = function(value) {
  return jspb.Message.setProto3IntField(this, 205, value);
};


/**
 * optional ResolutionChangeCapability resolution_change = 206;
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ResolutionChangeCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getResolutionChange = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ResolutionChangeCapability} */ (jspb.Message.getFieldWithDefault(this, 206, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ResolutionChangeCapability} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setResolutionChange = function(value) {
  return jspb.Message.setProto3EnumField(this, 206, value);
};


/**
 * optional ZoomCapability zoom = 207;
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ZoomCapability}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getZoom = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ZoomCapability} */ (jspb.Message.getFieldWithDefault(this, 207, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.ZoomCapability} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setZoom = function(value) {
  return jspb.Message.setProto3EnumField(this, 207, value);
};


/**
 * optional int32 detection_mode_motion = 301;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getDetectionModeMotion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 301, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setDetectionModeMotion = function(value) {
  return jspb.Message.setProto3IntField(this, 301, value);
};


/**
 * optional int32 detection_mode_person = 302;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getDetectionModePerson = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 302, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setDetectionModePerson = function(value) {
  return jspb.Message.setProto3IntField(this, 302, value);
};


/**
 * optional int32 detection_reminder = 303;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getDetectionReminder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 303, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setDetectionReminder = function(value) {
  return jspb.Message.setProto3IntField(this, 303, value);
};


/**
 * optional int32 detection_schedule = 304;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getDetectionSchedule = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 304, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setDetectionSchedule = function(value) {
  return jspb.Message.setProto3IntField(this, 304, value);
};


/**
 * optional int32 detection_zone = 305;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getDetectionZone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 305, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setDetectionZone = function(value) {
  return jspb.Message.setProto3IntField(this, 305, value);
};


/**
 * optional int32 live_and_detection = 306;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getLiveAndDetection = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 306, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setLiveAndDetection = function(value) {
  return jspb.Message.setProto3IntField(this, 306, value);
};


/**
 * optional int32 continuous_recording = 307;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getContinuousRecording = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 307, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setContinuousRecording = function(value) {
  return jspb.Message.setProto3IntField(this, 307, value);
};


/**
 * optional int32 camera_health = 401;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getCameraHealth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 401, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setCameraHealth = function(value) {
  return jspb.Message.setProto3IntField(this, 401, value);
};


/**
 * optional int32 camera_log = 402;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getCameraLog = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 402, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setCameraLog = function(value) {
  return jspb.Message.setProto3IntField(this, 402, value);
};


/**
 * optional int32 app_lock = 501;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getAppLock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 501, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setAppLock = function(value) {
  return jspb.Message.setProto3IntField(this, 501, value);
};


/**
 * optional int32 reboot_camera = 601;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getRebootCamera = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 601, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setRebootCamera = function(value) {
  return jspb.Message.setProto3IntField(this, 601, value);
};


/**
 * optional int32 network_status = 602;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getNetworkStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 602, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setNetworkStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 602, value);
};


/**
 * optional int32 firmware_update = 603;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getFirmwareUpdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 603, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setFirmwareUpdate = function(value) {
  return jspb.Message.setProto3IntField(this, 603, value);
};


/**
 * optional int32 sdcard_management = 604;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getSdcardManagement = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 604, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setSdcardManagement = function(value) {
  return jspb.Message.setProto3IntField(this, 604, value);
};


/**
 * optional int32 wifi_management = 605;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.getWifiManagement = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 605, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraDeviceCapabilityResponse.prototype.setWifiManagement = function(value) {
  return jspb.Message.setProto3IntField(this, 605, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraSnapshotRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraSnapshotRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    width: jspb.Message.getFieldWithDefault(msg, 1, 0),
    height: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraSnapshotRequest}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraSnapshotRequest;
  return proto.com.alfredcamera.protobuf.CameraSnapshotRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraSnapshotRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraSnapshotRequest}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraSnapshotRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraSnapshotRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 width = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSnapshotRequest} returns this
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 height = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSnapshotRequest} returns this
 */
proto.com.alfredcamera.protobuf.CameraSnapshotRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraSnapshotResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraSnapshotResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    snapshot: msg.getSnapshot_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraSnapshotResponse}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraSnapshotResponse;
  return proto.com.alfredcamera.protobuf.CameraSnapshotResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraSnapshotResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraSnapshotResponse}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSnapshot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraSnapshotResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraSnapshotResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSnapshot_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes snapshot = 1;
 * @return {!(string|Uint8Array)}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.prototype.getSnapshot = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes snapshot = 1;
 * This is a type-conversion wrapper around `getSnapshot()`
 * @return {string}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.prototype.getSnapshot_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSnapshot()));
};


/**
 * optional bytes snapshot = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSnapshot()`
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.prototype.getSnapshot_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSnapshot()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSnapshotResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSnapshotResponse.prototype.setSnapshot = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraStatusRequest}
 */
proto.com.alfredcamera.protobuf.CameraStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraStatusRequest;
  return proto.com.alfredcamera.protobuf.CameraStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraStatusRequest}
 */
proto.com.alfredcamera.protobuf.CameraStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && messaging_camera_status_pb.CameraRuntimeStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraStatusResponse}
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraStatusResponse;
  return proto.com.alfredcamera.protobuf.CameraStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraStatusResponse}
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new messaging_camera_status_pb.CameraRuntimeStatus;
      reader.readMessage(value,messaging_camera_status_pb.CameraRuntimeStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messaging_camera_status_pb.CameraRuntimeStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional CameraRuntimeStatus status = 1;
 * @return {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus}
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.prototype.getStatus = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraRuntimeStatus} */ (
    jspb.Message.getWrapperField(this, messaging_camera_status_pb.CameraRuntimeStatus, 1));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraRuntimeStatus|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraStatusResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraStatusResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraStatusResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ConfigReloadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ConfigReloadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ConfigReloadRequest}
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ConfigReloadRequest;
  return proto.com.alfredcamera.protobuf.ConfigReloadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ConfigReloadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ConfigReloadRequest}
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {!proto.com.alfredcamera.protobuf.ConfigReloadRequest.ConfigType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ConfigReloadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ConfigReloadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.ConfigType = {
  ALL: 0,
  FEATURES: 1,
  TRUST_CIRCLE: 2,
  DETECTION: 3
};

/**
 * optional ConfigType type = 2;
 * @return {!proto.com.alfredcamera.protobuf.ConfigReloadRequest.ConfigType}
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.prototype.getType = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.ConfigReloadRequest.ConfigType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.ConfigReloadRequest.ConfigType} value
 * @return {!proto.com.alfredcamera.protobuf.ConfigReloadRequest} returns this
 */
proto.com.alfredcamera.protobuf.ConfigReloadRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraHealthStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusRequest}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraHealthStatusRequest;
  return proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraHealthStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusRequest}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraHealthStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    supportedTipsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    statusCodesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraHealthStatusResponse;
  return proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSupportedTips(values[i]);
      }
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatusCodes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupportedTipsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getStatusCodesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * repeated int32 supported_tips = 1;
 * @return {!Array<number>}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.getSupportedTipsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.setSupportedTipsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.addSupportedTips = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.clearSupportedTipsList = function() {
  return this.setSupportedTipsList([]);
};


/**
 * repeated int32 status_codes = 2;
 * @return {!Array<number>}
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.getStatusCodesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.setStatusCodesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.addStatusCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.alfredcamera.protobuf.CameraHealthStatusResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraHealthStatusResponse.prototype.clearStatusCodesList = function() {
  return this.setStatusCodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraLogRequest}
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraLogRequest;
  return proto.com.alfredcamera.protobuf.CameraLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraLogRequest}
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.CameraLogRequest.CameraLogType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.CameraLogType = {
  SYSTEM_OVERVIEW: 0
};

/**
 * optional CameraLogType type = 1;
 * @return {!proto.com.alfredcamera.protobuf.CameraLogRequest.CameraLogType}
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.prototype.getType = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.CameraLogRequest.CameraLogType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.CameraLogRequest.CameraLogType} value
 * @return {!proto.com.alfredcamera.protobuf.CameraLogRequest} returns this
 */
proto.com.alfredcamera.protobuf.CameraLogRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraLogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    log: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraLogResponse}
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraLogResponse;
  return proto.com.alfredcamera.protobuf.CameraLogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraLogResponse}
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLog(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLog();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string log = 1;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.prototype.getLog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.CameraLogResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraLogResponse.prototype.setLog = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraInfoControls = {
  VIEWER_CAPS: 0,
  CAMERA_CAPS: 1,
  SNAPSHOT: 2,
  STATUS_REQUEST: 3,
  CONFIG_RELOAD: 5,
  CAMERA_HEALTH: 6,
  CAMERA_LOG: 7
};

goog.object.extend(exports, proto.com.alfredcamera.protobuf);
